import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

const state = {
    alarmNum: 0, // 企业告警数
    businessNum: 0, // 业务数据更新数
    currmenu: "",
    wxid: -1,
    pageTitle: "新泰市燃气智慧监管平台",
    themeTitle: "",
    http: "",
    todos: [
        { id: 1, text: "...", done: true },
        { id: 2, text: "...", done: false },
    ],
    isShade: true,
    isShowDialog: true,
    btnAdd: { type: "primary", icon: "", color: "", size: "" },
    btnSearch: { type: "primary", icon: "", color: "#fff", size: "" },
    btnDele: { type: "text", icon: "", color: "", size: "" },
    btnUpdate: { type: "text", icon: "", color: "", size: "" },
    btnConfirm: { type: "primary", icon: "", color: "", size: "" },
    btnCancel: { type: "primary", icon: "", color: "", size: "" },
    //行外修改  /删除
    btnlineouterUpdate: { type: "warning", icon: "", color: "", size: "" },
    btnlineouterDele: { type: "danger", icon: "", color: "", size: "" },
    csData: "",
    ipData: {},
    webpcUrl: "",
    tysjpt: false,
    superMapService: "http://192.168.9.105:8090",
    TqApi: "https://v0.yiketianqi.com/api?version=v9&appid=57666589&appsecret=MnwA9pBO&city=大庆",
    //   *************************************************************************************** 大庆现场
    wmmService: "http://112.98.114.74:11123/GateWayAPP/SynthesisAnalysis",
    dp_wmmService: "",
    dp_xlService: "",
    gyService: "http://112.98.114.74:11123/GateWayAPP/devicemanage",
    lylService: "http://112.98.114.74:11123/GateWayAPP/produce",

    dqgeoService: "http://112.98.114.74:18080",

    getBackUrl: "http://112.98.114.74:11123/yth/#/zhzs/zhzs",

    dywgeoService: "http://124.202.177.254:8080",
    heatNetSkip: "",
    //   *************************************************************************************** 阿里云
    // wmmService:'http://39.107.233.3:9901/GateWayAPP/SynthesisAnalysis',
    // gyService:'http://39.107.233.3:9901/GateWayAPP/devicemanage',
    // lylService:'http://39.107.233.3:9901/GateWayAPP/produce',
    // dqgeoService:'http://39.107.233.3:9901',

    // getBackUrl:'http://39.107.233.3:9901/yth/#/zhzs/zhzs',

    //  http://39.107.233.3:9901/yth/#/xtsz/qxpz

    // 本地
    wmmService: "http://192.168.9.105:10008",
    //  gyService:'http://192.168.9.102:10002',
    lylService: "http://192.168.9.107:10004",
    //  dqgeoService:'http://192.168.9.105:8080',
    //  getBackUrl:'http://192.168.9.101:8835/#/zhzs/zhzs',

    sourceService: "http://39.107.246.225:8090/GateWayPC/source", //资源
    sourceServiceNot: "http://39.107.246.225:8090/source", //资源不走网管
    kfService: "http://39.107.246.225:8090/GateWayPC/kf", //客服
    alarmService: "http://124.202.177.254:19909/GateWayPC/alarm", //告警
    alarmServiceNot: "http://124.202.177.254:19909/alarm", //告警不走网关
    jfService: "http://124.202.177.254:19909/GateWayPC/jf", //计费
    kejfService: "http://124.202.177.254:19909/GateWayPC/feeinterface", //客服计费
    formService: "http://124.202.177.254:19909/GateWayPC/formtask", //表单任务
    loginService: "https://xtrqaqjg.cn/jgapi/LoginAndSetting", //登录
    jfreportService: "http://124.202.177.254:19909/GateWayPC/jf-report", //李云龙服务
    jfreportServiceNot: "http://124.202.177.254:19909/jf-report", //不走网关
    kfreportService: "http://124.202.177.254:19909/GateWayPC/kf-report", //李云龙服务
    kfreportServiceNot: "http://124.202.177.254:19909/kf-report", //不走网关
    processService: "http://124.202.177.254:19909/GateWayPC/process", //徐龙服务
    jfService_not: "http://124.202.177.254:19909", //不走网关  (上传)
    httpWork: "http://124.202.177.254:19909/GateWayPC/process", //各类工单管理
    manageHttp: "http://124.202.177.254:19909/GateWayPC/jf", //管理接口
    order12345Service: "http://124.202.177.254:19909/GateWayPC/KF12345", //12345
    order12345ServiceNot: "http://124.202.177.254:19909/KF12345", //12345
    deviceManageService: "http://124.202.177.254:19909/GateWayPC/devicemanage", //设备管理
    deviceManageServiceNot: "http://124.202.177.254:19909/devicemanage", //设备管理不走网关
    imgIp: "http://124.202.177.254:19909/LoginAndSetting/img/", //图片
    qxbbService:
        "http://124.202.177.254:19909/GateWayPC/CommunicationReportService", //强讯报表
    qxService: "http://124.202.177.254:19909/CommunicationService", // 强讯 cti
    yjxyService: "http://124.202.177.254:19909/GateWayPC/yjxy", //应急响应
    yjxyServiceNot: "http://124.202.177.254:19909/yjxy", //应急响应
    //productionControlService:"http://124.202.177.254:19909/GateWayPC/produce",    //李云龙服务(生产)
    electronicService: "http://113.140.18.174:9901/electronic", //前川的开票
    leadcockpitutilService:
        "http://39.107.246.225:8090/GateWayPC/leadcockpitutil", //领导驾驶舱配置
    gisService: "http://124.202.177.254:19909/GateWayPC/tsprogram", //综合分析
    gisServiceNot: "http://124.202.177.254:19909/tsprogram", //

    SynthesisAnalysis: "http://124.202.177.254:10508",
    productionControlService: "http://124.202.177.254:10023",
    dataService: "http://192.168.9.107:10004",
    deviceService: "http://192.168.9.107:10002",
    EnterpriseService: "",
    ImgService: "",
    RLpath: "",
    RLGateway: "",
    RQGateway: "",
    //应急
    pollingService: "http://192.168.9.120:10002",
    reportHttp: "http://222.161.241.26",
    reportPort: ":9901/GateWayPC/QuerySB",
    yjxyloginPort: ":9901/GateWayPC/Yjxy",
    yjxyHttp: "http://222.161.241.26",
    userInfo: {},
    telCode: -1,
    telData: "",
    telTel: "",
    callid: "",
    TelephoneNumber: "", //座机号显示
    telState: true, //话务员右上角 座机显示
    projectname: "",
    projecttitle: "春城热力963963客服中心",
    JGDP: "",
    gyIP: "",
    dygeo: "",
    wmm: "",
    lyRequest: "",
    lyFileUpload: "",
    lyVideo: "",
    bigScreen: "",
    wsPath:""

    // loginHttp:'http://112.126.85.14',
    // http://192.168.9.105'
    // http://192.168.9.104'       石强
    // loginPort:':8081',
};

const mutations = {
    //this.$store.commit("setPageTitle ",'标题');
    setPageTitle(state, title) {
        // console.log(title)
        state.pageTitle = title;
        // console.log(state.pageTitle)
    },
    changes(state, n) {
        state.http = "https";
        state.aaa = n.aaa;
        state.projectname = n.projectname;
    },
    setThemeTitle(state, title) {
        state.themeTitle = title;
    },
    SET_ALARM_NUM(state, num) { // 告警数量
        state.alarmNum = num;
    },
    SET_BUSINESS_NUM(state, num) { // 业务数据数量
        state.businessNum = num;
    },
};
const getters = {
    toDo: (state) => {
        return state.todos.filter((item) => item.id >= 1);
    },
};


// 读取congig.json里IP
var param = new URLSearchParams();
axios.get("./static/config.json", param).then((res) => {
    if (res.status == 200) { 
        const frontUrl =process.env.NODE_ENV == "development"? res.data.DEV_BASE_API: res.data.PRODUCT_BASE_API;
        const wsUrl = process.env.NODE_ENV == "development" ? res.data.DEV_BASE_WS_API : res.data.PRODUCT_BASE_WS_API;
        state.sourceService = frontUrl + res.data.sourceService; //资源
        state.sourceServiceNot = frontUrl + res.data.sourceServiceNot; //资源不走网关
        state.kfService = frontUrl + res.data.kfService; //客服
        state.alarmService = frontUrl + res.data.alarmService; //告警
        state.alarmServiceNot = frontUrl + res.data.alarmServiceNot; //告警不走网关
        state.jfService = frontUrl + res.data.jfService; //计费
        state.kejfService = frontUrl + res.data.kejfService; //客服计费
        state.formService = frontUrl + res.data.formService; //表单任务
        state.loginService = frontUrl + res.data.loginService; //登录
        state.jfreportService = frontUrl + res.data.jfreportService; //李云龙服务
        state.jfreportServiceNot = frontUrl + res.data.jfreportServiceNot; //不走网关
        state.kfreportService = frontUrl + res.data.kfreportService; //李云龙服务
        state.kfreportServiceNot = frontUrl + res.data.kfreportServiceNot; //不走网关
        state.processService = frontUrl + res.data.processService; //徐龙服务
        state.jfService_not = frontUrl + res.data.jfService_not; //不走网关  (上传)
        state.httpWork = frontUrl + res.data.httpWork; //各类工单管理
        state.manageHttp = frontUrl + res.data.manageHttp; //管理接口
        state.order12345Service = frontUrl + res.data.order12345Service; //12345
        state.order12345ServiceNot = frontUrl + res.data.order12345ServiceNot; //12345
        state.deviceManageService = frontUrl + res.data.deviceManageService; //设备管理
        state.deviceManageServiceNot =
            frontUrl + res.data.deviceManageServiceNot; //设备管理不走网关
        state.imgIp = frontUrl + res.data.imgIp; //图片
        state.qxbbService = frontUrl + res.data.qxbbService; //强讯报表
        state.qxService = frontUrl + res.data.qxService; // 强讯 cti
        state.yjxyService = frontUrl + res.data.yjxyService; //应急响应
        state.yjxyServiceNot = frontUrl + res.data.yjxyServiceNot; //应急响应
        state.productionControlService =
            frontUrl + res.data.productionControlService; //李云龙服务(生产)
        state.electronicService = frontUrl + res.data.electronicService; //前川的开票
        state.leadcockpitutilService =
            frontUrl + res.data.leadcockpitutilService; //领导驾驶舱配置
        state.gisService = frontUrl + res.data.gisService; //综合分析
        state.gisServiceNot = frontUrl + res.data.gisServiceNot; //
        state.webpcUrl = frontUrl + res.data.webpcUrl; //weburl
        state.wmmService = frontUrl + res.data.wmmService;
        state.dp_wmmService = frontUrl + res.data.dp_wmmService;
        state.dp_xlService = frontUrl + res.data.dp_xlService;
        state.gyService = frontUrl + res.data.gyService;
        state.lylService = frontUrl + res.data.lylService;
        state.dqgeoService = frontUrl + res.data.dqgeoService;
        state.getBackUrl = frontUrl + res.data.getBackUrl;
        state.heatNetSkip = frontUrl + res.data.heatNetSkip;
        state.pollingService = frontUrl + res.data.pollingService;
        state.superMapService = frontUrl + res.data.superMapService;
        state.dataService = frontUrl + res.data.dataService;
        state.deviceService = frontUrl + res.data.deviceService;
        state.EnterpriseService = frontUrl + res.data.EnterpriseService;
        state.ImgService = frontUrl + res.data.ImgService;
        state.JGDP = frontUrl + res.data.JGDP;
        state.gyIP = frontUrl + res.data.gyIP;
        state.gyIPNot = frontUrl + res.data.gyIPNot;
        state.dygeo = frontUrl + res.data.dygeo;
        state.wmm = frontUrl + res.data.wmm;
        state.rqService = frontUrl + res.data.rqService;
        state.dyYjtbService = frontUrl + res.data.dyYjtbService;
        state.ntelligentNetwork = frontUrl + res.data.ntelligentNetwork;
        state.RLpath = frontUrl + res.data.RLpath;
        state.RLGateway = frontUrl + res.data.RLGateway;
        state.RQGateway = frontUrl + res.data.RQGateway;
        (state.lyRequest = frontUrl + res.data.HXHY_LY_INSPECTION),
            (state.lyFileUpload = frontUrl + res.data.HXHY_LY_FILE_UPLOAD),
            (state.lyVideo = frontUrl + res.data.HXHY_LY_VIDEO);
        state.bigScreen = frontUrl + res.data.bigScreen;
        state.wsPath = wsUrl
    }
});

const actions = {
    getAlarmNum: ({ commit }) => {
        return new Promise((resolve, reject) => {  
            axios.get(state.lyRequest + "/sysLog/getAlarmCountWithDay").then(
                (res) => { 
                    if (res.data.code == 200) {
                        commit("SET_ALARM_NUM", res.data.data);
                        resolve(res.data.data);
                    }
                },
                (error) => {
                    alert("请求失败");
                }
            );
        });
    },
    getBusinessNum: ({ commit }) => {
        return new Promise((resolve, reject) => { 
            
            axios.get(state.lyRequest + "/sysLog/getOperationCountWithDay").then(
                (res) => {
                    if (res.data.code == 200) {
                        commit("SET_BUSINESS_NUM", res.data.data);
                        resolve(res.data.data);
                    }
                },
                (error) => {
                    alert("请求失败");
                }
            );
        });
    },
};

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
});



// WEBPACK FOOTER //
// ./src/store/store.js